import { render, staticRenderFns } from "./TwLcLinking.vue?vue&type=template&id=346ad60b&scoped=true&"
import script from "./TwLcLinking.vue?vue&type=script&lang=js&"
export * from "./TwLcLinking.vue?vue&type=script&lang=js&"
import style0 from "./TwLcLinking.vue?vue&type=style&index=0&id=346ad60b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346ad60b",
  null
  
)

export default component.exports